import classNames from 'classnames';
import type { ReactNode } from 'react';

import {
  fontFamily,
  fontWeight,
  textSizeTrimmed,
  textSizeUntrimmed,
  tone as textTone,
  textWrapBalance,
} from '../../css/typography.css';
import { Box, type BoxProps } from '../Box/Box';

export interface TextProps {
  id?: string;
  tone?: keyof typeof textTone;
  weight?: keyof typeof fontWeight;
  size?: keyof typeof textSizeTrimmed;
  align?: BoxProps['textAlign'];
  /** capitalize, uppercase or lowercase the provided text */
  transform?: BoxProps['textTransform'];
  untrimmed?: boolean;
  decoration?: BoxProps['textDecoration'];
  className?: string;
  children?: ReactNode;
  htmlFor?: string;
  display?: 'block' | 'inline';
  title?: string;
  textWrapBalance?: boolean | null | undefined;
}

/**
 * @deprecated Use Mantine's Text component instead.
 * Import: import { Text } from '@mantine/core'
 */
export const Text = ({
  ref,
  id,
  size = 'medium',
  weight = 'regular',
  tone = 'neutral',
  align,
  transform,
  untrimmed,
  className,
  children,
  decoration,
  htmlFor,
  title,
  textWrapBalance: textWrapBalanceProp,
  display = 'block',
}: TextProps & {
  ref?: React.Ref<HTMLSpanElement>;
}) => {
  return (
    <Box
      id={id}
      display={display}
      component="span"
      textAlign={align}
      textTransform={transform}
      textDecoration={decoration}
      className={classNames(
        fontFamily,
        fontWeight[weight],
        textTone[tone],
        untrimmed ? textSizeUntrimmed[size] : textSizeTrimmed[size],
        textWrapBalanceProp && textWrapBalance,
        className,
      )}
      ref={ref}
      htmlFor={htmlFor}
      title={title}
    >
      {children}
    </Box>
  );
};

Text.displayName = 'Text';
